export const checkPasswordRules = (password) => ({
  length: password.length >= 8,
  upper: /[A-Z]/.test(password),
  lower: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
});

export const isPasswordValid = (password) => {
  const rules = checkPasswordRules(password);
  return Object.values(rules).every(Boolean);
};

